module.exports = __webpack_public_path__ + "img/SKMJ_crain7.072d4709.png";